module.exports = __webpack_public_path__ + "img/img-2.750ced6e.jpg";